import { render, staticRenderFns } from "./RequiredServices.vue?vue&type=template&id=0a696376&scoped=true"
import script from "./RequiredServices.vue?vue&type=script&lang=ts"
export * from "./RequiredServices.vue?vue&type=script&lang=ts"
import style0 from "./RequiredServices.vue?vue&type=style&index=0&id=0a696376&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a696376",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a696376')) {
      api.createRecord('0a696376', component.options)
    } else {
      api.reload('0a696376', component.options)
    }
    module.hot.accept("./RequiredServices.vue?vue&type=template&id=0a696376&scoped=true", function () {
      api.rerender('0a696376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/ClientRightSide/RequiredServices.vue"
export default component.exports